export interface PublicacionesModel {
  titulo_publicacion: string;
  tema: string;
  ciudad: string;
  año: string;
  descripcion: string;
  documento: string;
}

export const initialValuesPublicacionesmodel = {
  titulo_publicacion: "",
  tema: "",
  ciudad: "",
  año: "",
  descripcion: "",
  documento: "",
};
